export default function VideoModal({ onClose }) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9998,
        background: 'rgba(0,0,0,0.93)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '90%',
          maxWidth: 900,
          borderRadius: 14,
          overflow: 'hidden',
          position: 'relative',
          boxShadow: '0 0 80px rgba(230,88,38,0.2)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <img src="/assets/skool-screenshot.png" alt="Random College preview" style={{ width: '100%', display: 'block' }} />
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: 'rgba(230,88,38,0.92)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg width="24" height="28" viewBox="0 0 22 26" fill="white">
            <path d="M0 0L22 13L0 26V0Z" />
          </svg>
        </div>
        <button
          aria-label="Cerrar"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 16,
            right: 16,
            width: 36,
            height: 36,
            borderRadius: '50%',
            background: 'rgba(0,0,0,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            color: 'white',
            cursor: 'pointer',
            border: '1px solid rgba(255,255,255,0.15)',
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
}
